import { queryOptions } from '@tanstack/react-query';

import TaskService from './taskService';

// **** Queries **** //

export const getTaskQueryOptions = {
  nonPhysicalTasks: () =>
    queryOptions({
      queryKey: ['nonPhysicalTasks'] as const,
      queryFn: () => TaskService.fetchNonPhysicalTasks(),
    }),
};

// **** Mutations **** //

export const getTaskMutationOptions = {
  nonPhysicalTasks: {
    create: () => ({
      mutationFn: TaskService.createNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Created Non-Physical Task successfully',
      },
    }),
    update: () => ({
      mutationFn: TaskService.updateNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Saved Non-Physical Task successfully',
      },
    }),
    delete: () => ({
      mutationFn: TaskService.deleteNonPhysicalTask,
      meta: {
        invalidates: [getTaskQueryOptions.nonPhysicalTasks().queryKey],
        successMessage: 'Deleted Non-Physical Task successfully',
      },
    }),
  },
};
